export const SUPPORT_EMAIL = "support@plenum-ai.com"
